"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CommentFormImpl_1 = require("./impl/CommentFormImpl");
class CommentForm extends CommentFormImpl_1.default {
    render() {
        return (React.createElement("div", { className: "post-comment-add" },
            React.createElement("div", { className: "block-title" },
                React.createElement("h3", null, "Leave a Comment")),
            React.createElement("form", { onSubmit: this.onCommentSubmit },
                React.createElement("div", { className: "form-group" },
                    React.createElement("input", { className: "form-control", placeholder: "Your name", name: "name", type: 'text', required: true, onChange: this.nameChange, value: this.state.name }),
                    React.createElement("div", { className: "form-control-border" }),
                    React.createElement("i", { className: "form-control-icon fa fa-user" })),
                React.createElement("div", { className: "form-group" },
                    React.createElement("input", { className: "form-control", placeholder: "Your emal", type: 'email', required: true, onChange: this.emailChange, value: this.state.email }),
                    React.createElement("div", { className: "form-control-border" }),
                    React.createElement("i", { className: "form-control-icon fa fa-user" })),
                React.createElement("div", { className: "form-group" },
                    React.createElement("textarea", { className: "form-control", rows: 3, required: true, onChange: this.commentChange, value: this.state.text, placeholder: "Message...", name: "message" }),
                    React.createElement("div", { className: "form-control-border" }),
                    React.createElement("i", { className: "form-control-icon fa fa-comment" })),
                React.createElement("button", { className: "button", type: "submit" }, "Add comment"))));
    }
}
exports.default = CommentForm;
